/* globals cpac, my_isset, AutoComplete, $, showAjaxStarted, Ajax, showAjaxFinished, SearchResultWindow, reportAjaxError */

if (typeof cpac !== 'undefined') {
  cpac.autocomplete = {
    basic: {
        _listTitle: 'Which name are you looking for?',
  
        list: function (url, nameFieldId, valueFieldId, extraData, callBack) {
            var field = $(nameFieldId);
            if (field && (!field.acobject || field.acobject == undefined)) {
                extraData = my_isset(extraData) ? extraData : '';
                var options = {
                     script: function (input) {return (url + '&input=' + input + extraData);},
                     callback: function (obj) {
                            $(valueFieldId).value = obj.id;
                            if ($(valueFieldId).onchange) $(valueFieldId).onchange();
                            if (my_isset(callBack)) {
                                callBack(obj);
                            }
                    }
                };
                field.acobject = new AutoComplete(nameFieldId,options);
            }
            return true;
        },
        extList: function (url, nameFieldId, valueFieldId, extraData, callBack, listTitle, onEnter, noautocomplete) {
            if (listTitle == undefined) listTitle = this._listTitle;
            var field = $(nameFieldId);
            if (field && (!field.acobject || field.acobject == undefined)) {
                extraData = my_isset(extraData) ? extraData : '';
                var options = {
                     script: function (input) {return (url + '&input=' + input + extraData);},
                     callback: function (obj) {
                            $(valueFieldId).value = obj.id;
                            if (typeof obj.value !== 'undefined') {
                                field.setAttribute('data-name', obj.value);
                            }
                            if ($(valueFieldId).onchange) $(valueFieldId).onchange();
                            if (my_isset(callBack)) {
                                callBack(obj.id, obj.value, obj.extra, obj.info);
                            }
                    },
                    onenter: function() {
                        if (typeof(onEnter) == 'function') {
                            onEnter(url, field.value, nameFieldId, valueFieldId, extraData, callBack, listTitle);
                        } else {
                            cpac.autocomplete.basic.onEnter(url, field.value, nameFieldId, valueFieldId, extraData, callBack, listTitle);
                        }
                    }
                };
                if (noautocomplete != undefined && noautocomplete == true) {
                    field.acobject = options;
                    Event.observe(field, 'keypress', function(e) {
                        if (!e) e = window.event;
                        var key	= e.keyCode || e.which;
  
                        switch(key) {
                            case Event.KEY_RETURN:
                                options.onenter(field.value);
                                break;
                        }
                    });
                } else {
                    field.acobject = new AutoComplete(nameFieldId, options);
                }
            }
            return true;
        },
        onEnter: function (url, value, nameFieldId, valueFieldId, extraData, callBack, listTitle, autoSubmitOne) {
            var field = $(nameFieldId);
            autoSubmitOne = autoSubmitOne == undefined ? true : autoSubmitOne;
            if(!field /*|| !field.value || field.value.length == 0*/) return;
            if(field.acobject && typeof(field.acobject.clearSuggestions) == 'function') {
                field.acobject.clearSuggestions();
            }
            if(typeof(showAjaxStarted) == 'function') showAjaxStarted();
  
            var resultClick = function( xmlRow ) {
                var id = xmlRow.getAttribute('id');
                var value = xmlRow.childNodes[0].nodeValue;
                var extra = xmlRow.getAttribute('extra');
                var info = xmlRow.getAttribute('info');
  
                $(valueFieldId).value = id;
                $(nameFieldId).value = value;
                if ($(valueFieldId).onchange) $(valueFieldId).onchange();
                if (my_isset(callBack) && typeof(callBack) == 'function') {
                    callBack(id, value, extra, info);
                }
            }
            extraData = my_isset(extraData) ? extraData : '';
  
            new Ajax.Request(url, {
                method:'get',
                parameters: 'input=' + value + '&list=1' + extraData,
                onSuccess: function(transport){
                    if(typeof(showAjaxFinished) == 'function') showAjaxFinished(transport);
                    var results = transport.responseXML.getElementsByTagName('results')[0].childNodes;
                    if (results.length > 0) {
                        if (results.length == 1 && autoSubmitOne) {
                            resultClick(results[0]);
                        } else {
                            var frame = new SearchResultWindow({
                                descr: '',
                                title: listTitle,
                                onClickRow: resultClick
                            });
                            frame.showSearchResultsList( results );
                        }
                    }
                },
                onFailure: function(transport) {
                    if(typeof(reportAjaxError) == 'function') reportAjaxError(transport);
                }
            });
        }
    },
    accounting: {
        _nameFieldId: null,
        _valueFieldId: null,
        _callBack: null,
        _extraData: null,
        _onKeyPressedHandler: null,
        _listTitle: 'Which Accounting Group are You Looking For?',
  
        list: function (nameFieldId, valueFieldId, descrField, extraData) {
            if (my_isset(descrField)) {
                var callBack = function (obj) {
                    descrField.style.display = obj.extra == 1 ? 'none' : '';
                }
            } else {
                callBack = null;
            }
            return cpac.autocomplete.basic.list('/accounting/auto?auto=true', nameFieldId, valueFieldId, extraData, callBack);
        },
        extList: function (nameFieldId, valueFieldId, descrField, extraData) {
            if (my_isset(descrField)) {
                var callBack = function (id, value, extra) {
                    descrField.style.display = extra == 1 ? 'none' : '';
                }
            } else {
                callBack = null;
            }
            return cpac.autocomplete.basic.extList('/accounting/auto?auto=true', nameFieldId, valueFieldId, extraData, callBack);
        },
        startListening: function(nameFieldId, valueFieldId, descrField, extraData) {
            try {
                this.stopListening();
                this._nameFieldId = nameFieldId;
                this._valueFieldId = valueFieldId;
                this._extraData = extraData;
                if (my_isset(descrField)) {
                    this._callBack = function (id, value, extra) {
                        descrField.style.display = extra == 1 ? 'none' : '';
                    }
                } else {
                    this._callBack = null;
                }
                this._onKeyPressedHandler = this._onKeyPressed.bind(this);
  
                Event.observe(document, 'keypress', this._onKeyPressedHandler);
            } catch(e) {
                cpac.error(e);
            }
        },
        stopListening: function() {
            this._nameFieldId = null;
            this._valueFieldId = null;
            this._callBack = null;
            this._extraData = null;
  
            if (this._onKeyPressedHandler) {
                Event.stopObserving(document, 'keypress', this._onKeyPressedHandler);
            }
        },
        pauseListening: function () {
            if (this._onKeyPressedHandler) {
                Event.stopObserving(document, 'keypress', this._onKeyPressedHandler);
            }
        },
        resumeListening: function () {
            if (this._onKeyPressedHandler) {
                Event.stopObserving(document, 'keypress', this._onKeyPressedHandler);
                Event.observe(document, 'keypress', this._onKeyPressedHandler);
            }
        },
        _onKeyPressed: function(ev) {
            if (!this._nameFieldId) {
                Event.stop(ev);
            }
            var keyCode = ev.which ? ev.which : ev.keyCode;
            if(keyCode == 13 || keyCode == 10) {
                if (this._nameFieldId) {
                    this.onEnter(
                        '',
                        this._nameFieldId,
                        this._valueFieldId,
                        this._extraData,
                        this._callBack,
                        this._listTitle);
                } else {
                    Event.stop(ev);
                }
            }
        },
        onEnter: function (value, nameFieldId, valueFieldId, extraData, callBack, listTitle) {
            cpac.autocomplete.basic.onEnter('/accounting/auto?auto=true', value, nameFieldId, valueFieldId, extraData, callBack, listTitle);
        }
  
    },
  staff: {
    _nameFieldId: null,
        _valueFieldId: null,
        _callBack: null,
        _extraData: null,
  
        list: function (nameFieldId, valueFieldId, extraData) {
            var callBack = function (obj) {
        try {
          var field = $(nameFieldId);
                cpac.autocomplete.staff.insertFbBox(field, obj.id, obj.value);
        } catch(e) {
        cpac.error(e);
        }
  
      }
            return cpac.autocomplete.basic.list('/user/auto?auto=true', nameFieldId, valueFieldId, extraData, callBack);
        },
  
    clear: function (staffBlock) {
      try {
          var staffParent = staffBlock.parentNode;
      var nameField = staffBlock.nextSibling;
      var valueField = nameField.nextSibling;
      staffParent.removeChild(staffBlock);
      nameField.value = ''
      Element.show(nameField);
      valueField.value = '';
            if (typeof (valueField.onchange) == 'function') {
                valueField.onchange();
            }
      } catch(e) {
      cpac.error(e);
      }
    },
        
        insertFbBox: function (field, userId, userName) {
            var staffBlock = document.createElement('div');
            staffBlock.className = 'fb-user-box';
            staffBlock.innerHTML = '<a onclick="cpac.autocomplete.staff.clear(this.parentNode)" href="javascript:void(0)" class="fb-user-box-close"></a>' +
                                   '<a href="/user/edit/?id='+userId+'" class="fb-user-box-title">'+userName+'</a>';
  
            Element.hide(field);
            var fieldParent = field.parentNode;
            fieldParent.insertBefore(staffBlock, field);
        }
  },
  acctg_box: {
    _nameFieldId: null,
        _valueFieldId: null,
        _callBack: null,
        _extraData: null,
  
        list: function (nameFieldId, valueFieldId, extraData) {
            var callBack = function (obj) {
        try {
          var field = $(nameFieldId);
        var staffBlock = document.createElement('div');
        staffBlock.className = 'fb-user-box';
        staffBlock.innerHTML = '<a onclick="cpac.autocomplete.acctg_box.clear(this.parentNode)" href="javascript:void(0)" class="fb-user-box-close"></a>' +
                     '<a class="fb-user-box-title">'+obj.value+'</a>';
        Element.hide(field);
        var fieldParent = field.parentNode;
        fieldParent.insertBefore(staffBlock, field);
        } catch(e) {
        cpac.error(e);
        }
  
      }
            return cpac.autocomplete.basic.list('/accounting/auto?auto=true', nameFieldId, valueFieldId, extraData, callBack);
        },
  
    clear: function (staffBlock) {
      try {
          var staffParent = staffBlock.parentNode;
      var nameField = staffBlock.nextSibling;
      var valueField = nameField.nextSibling;
      staffParent.removeChild(staffBlock);
      nameField.value = ''
      Element.show(nameField);
      valueField.value = '';
            if (typeof (valueField.onchange) == 'function') {
                valueField.onchange();
            }
      } catch(e) {
      cpac.error(e);
      }
    }
  },
    discount: {
        _nameFieldId: null,
        _valueFieldId: null,
        _callBack: null,
        _extraData: null,
        _onKeyPressedHandler: null,
        _listTitle: 'Which Coupon are You Looking For?',
  
        list: function () {
            return false;
        },
        extList: function (nameFieldId, valueFieldId, descrField, extraData) {
            var callBack = function () {
                var field = $(nameFieldId);
                var form = field.form;
                if (form && form.save_discount) {
                    form.save_discount.onclick();
                }
            }
            return cpac.autocomplete.basic.extList('/payment/auto?auto=true', nameFieldId, valueFieldId, extraData, callBack, this._listTitle, this.onEnter, true);
        },
        onEnter: function (url, value, nameFieldId, valueFieldId, extraData, callBack, listTitle) {
            if (value != '') {
                var field = $(nameFieldId);
                var form = field.form;
                if (form && form.save_discount) {
                    form.save_discount.onclick();
                    return;
                }
            }
            var autoSubmitOne = false;
            cpac.autocomplete.basic.onEnter(url, value, nameFieldId, valueFieldId, extraData, callBack, listTitle, autoSubmitOne);
        }
  
    }
  }
}